// opervex-frontend/src/Opervex/Unifique/Services.js

class Services {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async getDataByURL(url) {
    return this.#_api.post("/Unifique/Services/ConvertServiceUrl", { url });
  }
}

export default Services;
